export default function getErrorMessage(data, type) {
  return (
    data?.errors?.map((error) => error.message).join(". ") ||
    `${data?.message}. ${data?.response?.statusText || ""}` ||
    `${data}. ${type ?? ""}`
  ).replace("..", ".");
}
